<!--头部显示-->
<template>
	<div class="topMenu" v-if="enable">
		
		<div class="leftPart">
			<div style="width: 185px;height: 48px;" class="flexCenter" :title="nowUnit.name">
				<img :src="logoFile" class="logo" alt="" />

			</div>
			<span>
				<div class="unitSelect flexCenter">
					<span @mouseenter="shouMenu = true" @mouseleave="shouMenu = false" class="unitName" >{{nowUnit.name}}</span>
					<div class="flexCenter">
						<listView :dataList="unitList" class="filterDialog" v-show="filterName" @checkItem="$store.unitStore.commit('setNowUnit',$event.id),filterName = undefined"></listView>
					</div>
				</div>
				<div class="unitMenu" v-show="shouMenu" @mouseenter="shouMenu = true" @mouseleave="shouMenu = false">
					<unitTree class='hideBar' @checkItem='checkItem' :fllowCache='true'>
					</unitTree>
				</div>
			</span>
			<!--通讯状态-->
			<span>通讯状态</span>
		</div>
		<div class="rightPart">
			<div class="firstStairMenuContainer custom-scrollbar">
				<div class="flexBetween">
					<div class="firstStairMenu" v-for="(menu,index) in dataList" :key="menu.id" 
					:class="{'firstStairMenuAct':nowSelectedMenuId == menu.id}" 
					@click="menuClick(menu,index)">
						<img :src="getResourcesByName('menu/'+menu.iconFile+'.png')" alt="" />
						<span>{{menu.rightname}}</span>
					</div>
				</div>
			</div>
			<img style="width: 25px;height: 25px;margin: 0 10px;cursor: pointer;flex-shrink: 0;" :src="getResourcesByName('topMenu/changeMenuType.png')" @click="$emit('menuTypeChange')" alt="" />
			<div style="cursor: pointer;height: 48px;padding: 0 15px;" class="flexCenter" @mouseenter="showMsg = true" @mouseleave="showMsg = false">
				<img :src="getResourcesByName('topMenu/msg.png')" alt="" style="width: .25rem;height: .25rem;" title="最新消息">
				<span class="existMsg" v-show="existMsg">{{unReadNum}}</span>
				<transition name="nomal-fade">
					<div v-show="showMsg" class="msgDialog">
						<div class="msgOperate">
							<button @click="filterUnreadMsg" :class="{'isFilter':filterStatus}">未读消息</button>
							<button @click="$router.push('/events')" class="isFilter">打开事件管理</button>
						</div>
						<listView :dataList="msgList" style="height: calc(100% - 50px);">
							<template v-slot:default="slotProps">
								<div v-if="slotProps.item.type == 'tips'">
									<p style="text-align: center;line-height: 36px;border-bottom: dashed 1px #CCCCCC;">{{slotProps.item.name}}</p>
								</div>
								<div v-else class="unreadMsgInfo" :class="{'unReadMsg':slotProps.item.unReaded}">
									<div class="unreadHead">
										<span class="msgTypeName">{{slotProps.item.typeName}}</span>
										<button class="msgMarkBtn" v-if="slotProps.item.unReaded" @click="markUnreadMsg(slotProps.item)">标记为已读</button>
										<span class="msgTimeText" v-else>{{slotProps.item.timeText}}</span>
									</div>
									<p class="msgIntro">{{slotProps.item.description}}</p>
								</div>
							</template>
						</listView>
					</div>
				</transition>
			</div>
			<div class="leftPartImg" @mouseenter="shouMenus = true" @mouseleave="shouMenus = false">
				<img :src="getUserImg" style="margin-right: 0.1rem;" class="user" />
				<img :src="getUserSelectImg" class="userSelect" alt="" />
			</div>
			<div class="userMenu" v-show="shouMenus" @mouseenter="shouMenus = true" @mouseleave="shouMenus = false">
				<div class="menuItem">
					<span class="userName">{{userName}}</span>
				</div>
				<div class="menuItem" @mouseenter="editPasswordImg = true" @mouseleave="editPasswordImg = false" @click.stop="updatePSW">
					<img :src="getEditPasswordImg" alt="" />
					<span v-if="editPasswordImg" style="color: #004189;">修改密码</span>
					<span v-else>修改密码</span>
				</div>
				<div class="menuItem" @mouseenter="exitImg = true" @mouseleave="exitImg = false" @click.stop="logout">
					<img :src="getExitImg" alt="" />
					<span v-if="exitImg" style="color: #004189;">退出</span>
					<span v-else>退出</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import unitTree from '@/components/module/tree/unitTree.vue'
	import menuStore from '@/cache/menuStore.js'
	import cacheStore from '@/cache/cacheStore.js'
	import resourcesStore from '@/cache/resourcesStore.js'
	import updatePSWDialog from '@/components/module/dialog/updatePSWDialog.vue'
	import listView from '@/components/module/selection/base/listView.vue'
	export default {
		components: {
			unitTree,
			listView,
		},
		props: {
			dataList: {
				type: Array,
				required: true,
			}
		},
		data() {
			return {
				editPasswordImg: false,
				exitImg: false,
				shouMenu: false,
				shouMenus: false,
				showMsg: false,
				filterName: undefined,
				filterStatus: false,
				nowSelectedMenuId: undefined
			}
		},
		created() {},
		mounted() {
			debugPage = this
			var nowMenuSort = localStorage.getItem('nowMenuSort')
			var topMenuIndex = nowMenuSort == undefined ? '0' : nowMenuSort.charAt(0)
			this.menuClick(this.dataList[topMenuIndex], topMenuIndex)
		},
		destroyed() {},
		computed: {
			menuStore() {
				return this.$store.menuStore
			},
			nowMenu(){
				return this.menuStore.state.nowMenu
			},
			userName() {
				var userInfo = this.$store.userStore.state.nowUserInfo
				return userInfo.username
			},
			getEditPasswordImg() {
				if(this.editPasswordImg) {
					return this.getResourcesByName('topMenu/editPasswordClick.png')
				}
				return this.getResourcesByName('topMenu/editPassword.png')
			},
			getExitImg() {
				if(this.exitImg) {
					return this.getResourcesByName('topMenu/exitClick.png')
				}
				return this.getResourcesByName('topMenu/exit.png')
			},
			getUserImg() {
				if(!this.shouMenus) {
					return this.getResourcesByName('topMenu/user.png')
				}
				return this.getResourcesByName('topMenu/userClick.png')
			},
			getUserSelectImg() {
				if(!this.shouMenus) {
					return this.getResourcesByName('topMenu/userSelect.png')
				}
				return this.getResourcesByName('topMenu/userSelectClick.png')
			},
			enable() {
				return menuStore.state.showTopMenu
			},
			getResourcesByName() {
				return resourcesStore.getters.getResourcesByName
			},
			title() {
				return this.$store.cacheStore.getters.getWebConfig.Title
			},
			logoFile() {
				if(isempty(this.$store.cacheStore.getters.getWebConfig)) {
					return ''
				}
				return 'data:image/png;base64,' + this.$store.cacheStore.getters.getWebConfig.LogoFile
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			msgList() {
				//只保留最新的100条消息，而且刷新就移除
				var list = this.$store.socketStore.state.msgList.filter((item, index) => index < 100)
				if(isempty(list)) {
					list.push({
						type: 'tips',
						name: '没有更多消息了'
					})
				}

				if(this.filterStatus) {
					return list.filter(item => {
						return item.hasOwnProperty('unReaded')
					})
				} else {
					return list
				}
			},
			unitList() {
				//单位列表
				var list = this.$store.unitStore.getters.getUnitList
				//过滤出当前输入的
				if(!isempty(this.filterName)) {
					list = list.filter(item => item.name.includes(this.filterName))
				}
				if(isempty(list)) {
					return [{
						type: 'tips',
						name: '---- 匹配不到任何单位名称 ----'
					}]
				}
				return list
			},
			filterIco() {
				return isempty(this.filterName) ? this.getResourcesByName('topMenu/search.png') : this.getResourcesByName('topMenu/close.png')
			},
			// 当前存在未读消息计算
			existMsg() {
				for(var i = this.msgList.length - 1; i >= 0; i--) {
					if(this.msgList[i].hasOwnProperty('unReaded')) {
						return true
					}
				}
				return false
			},
			// 当前未读消息的个数
			unReadNum() {
				var total = 0;
				for(var i = 0; i < this.msgList.length; i++) {
					if(this.msgList[i].hasOwnProperty('unReaded')) {
						total++
					}
				}
				return total
			}
		},
		watch: {
			dataList(nv, ov){
				var nowMenuSort = localStorage.getItem('nowMenuSort')
				var topMenuIndex = nowMenuSort == undefined ? '0' : nowMenuSort.charAt(0)
				this.menuClick(this.dataList[topMenuIndex], topMenuIndex)
			}
		},
		methods: {
			checkItem(item) {
				this.$store.unitStore.commit("setNowUnit", item.id)
				this.$store.unitStore.commit("setUnitGroupNo", item.id)
			},
			menuClick(menu, index) {
				if(isempty(menu)){
					return
				}
				this.nowSelectedMenuId = menu.id
				if(menu.hasOwnProperty('next')){
					this.menuStore.commit('setSeparationMenuLeftData', menu.next)
				}else{
					this.menuStore.commit('setSeparationMenuLeftData', [])
				}
				this.$emit('checkItem', menu)
			},
			updatePSW() {
				//修改密码
				this.shouMenus = false
				var dialogVM = this.$dialogMethod.createDialog(updatePSWDialog)
				dialogVM.show()
			},
			logout() {
				this.shouMenus = false
				this.$store.menuStore.commit('clear')
				this.$dialogMethod.showLoading("正在注销...")
				this.$api.userApi.logout(respon => {
					//清理所有缓存
					toLogin()
				})
			},
			// 过滤显示的消息
			filterUnreadMsg() {
				this.filterStatus = !this.filterStatus
			},
			// 标记为已读消息
			markUnreadMsg(item) {
				this.$delete(item, 'unReaded')
			}
		}
	}
</script>

<style scoped>
	.topMenu {
		background: #287AF4;
		height: .7rem;
		overflow-y: hidden;
		overflow: hidden;
		display: flex;
		width: 100%;
		justify-content: space-between;
		align-items: center;
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}
	
	.userName {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	
	.leftPart {
		width: 450px;
		margin-left: .1rem;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		background-color: red;
	}
	
	.logo {
		max-width: 185px;
		max-height: 40px;
	}
	
	.rightPart {
		width: calc(100% - 450px);
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	
	.leftPartImg {
		height: 48px;
		display: flex;
		align-items: center;
		width: 100px;
	}
	
	.rightPart .user {
		width: auto;
		margin-left: 25px;
		max-width: 2rem;
		min-width: .2rem;
		height: .2rem;
	}
	
	.rightPart .userSelect {
		cursor: pointer;
		width: auto;
		max-width: 2rem;
		min-width: .08rem;
		height: .06rem;
		margin-right: 20px;
		margin-top: 11px;
	}
	
	.unitSelect {
		margin-left: .05rem;
		min-width: 1rem;
		height: 100%;
		height: 48px;
	}
	
	.userMenu {
		top: 20px;
		padding-top: .5rem;
		position: absolute;
		z-index: 2;
	}
	
	.unitMenu {
		max-width: 4rem;
		height: 4rem;
		margin-left: .1rem;
		top: 20px;
		padding-top: .5rem;
		position: absolute;
		z-index: 2;
	}
	
	.unitMenu .readDeviceTreeBody {
		border-width: 1px;
		border-style: solid;
		border-radius: 0 0 10px 10px;
	}
	
	.menuItem {
		height: 33px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: .05rem .1rem;
		width: auto;
		cursor: pointer;
		background: white;
		border-left: solid .01rem #BABEC2;
		border-right: solid .01rem #BABEC2;
		border-bottom: solid .01rem #BABEC2;
	}
	
	.menuItem:last-child {
		border-radius: 0 0 .05rem .05rem;
	}
	
	.menuItem>span {
		text-align: left;
		width: .7rem;
		padding-left: .1rem;
	}
	
	.tool-class {
		width: 50%;
	}
	
	.msgDialog {
		position: absolute;
		width: 360px;
		height: 440px;
		background: white;
		z-index: 5;
		top: 70px;
		right: 20px;
		border-radius: 5px;
		border: 1px silver solid;
	}
	
	.msgDialog>p {
		padding-right: 20px;
		line-height: 40px;
		text-align: right;
		border-bottom: 1px silver solid;
		color: #0092DC;
	}
	/* 修改默认列表样式 */
	
	.msgDialog>>>ul.list-body {
		border-radius: 0;
	}
	
	.msgDialog>>>ul.list-body>li {
		padding: 0;
		border-bottom: none;
		background: none;
		cursor: default;
	}
	
	.msgOperate {
		overflow: hidden;
		padding: 0 24px;
		border-bottom: solid 1px #CCCCCC;
	}
	
	.msgOperate>button {
		height: 20px;
		box-sizing: border-box;
		margin: 8px 12px;
		color: #0F87DB;
		padding: 0 8px;
		background: #FFFFFF;
		outline: none;
		border: solid 1px #FFFFFF;
		border-radius: 10px;
		cursor: pointer;
	}
	
	.msgOperate>.isFilter {
		border-color: #0F87DB;
	}
	
	.msgOperate>span {
		float: right;
		line-height: 36px;
	}
	
	.filterDialog {
		position: absolute;
		height: 300px;
		width: 250px;
		background: white;
		top: 50px;
		z-index: 100;
	}
	
	.unitName {
		max-width: 140px;
		white-space: nowrap;
		display: inline-block;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	
	.existMsg {
		position: absolute;
		right: 166px;
		top: 12px;
		width: 20px;
		height: 20px;
		border-radius: 50%;
		background: red;
		color: #FFFFFF;
		font-size: .12rem;
		text-align: center;
		line-height: 20px;
		transform: scale(0.6);
	}
	
	.unreadMsgInfo {
		padding: 10px 24px 0 24px;
	}
	
	.unreadHead {
		margin-bottom: 6px;
		overflow: hidden;
	}
	
	.msgTypeName {
		float: left;
		background: #0582DA;
		line-height: 18px;
		padding: 0 8px;
		border-radius: 8px;
		font-size: .12rem;
		color: #FFFFFF;
	}
	
	.msgMarkBtn {
		float: right;
		height: 18px;
		box-sizing: border-box;
		border: solid 1px #0F87DB;
		border-radius: 8px;
		font-size: .12rem;
		padding: 0 8px;
		line-height: 16px;
		color: #0F87DB;
		background: #FFFFFF;
		cursor: pointer;
	}
	
	.msgTimeText {
		float: right;
		line-height: 18px;
		font-size: .12rem;
		color: #0F87DB;
	}
	
	.msgIntro {
		font-size: .12rem;
		text-indent: 2em;
		padding-bottom: 10px;
		border-bottom: solid 1px #CCCCCC;
		white-space: normal;
	}
	
	.unReadMsg {
		background-color: #E3EBF1;
	}
	
	.firstStairMenuContainer{
		max-width: calc(100% - 200px);
		overflow-x: auto;
	}
	
	.firstStairMenu{
		flex-basis: 80px;
		height: 60px;
		display: inline-flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 0 10px;
		cursor: pointer;
	}
	
	.firstStairMenu:hover{
		background-color: #488EF6;
	}
	
	.firstStairMenu>img{
		width: 20px;
		height: 20px;
		margin: 8px 0;
	}
	
	.firstStairMenu>span{
		color: #FFFFFF;
		font-size: .14rem;
		white-space: nowrap;
	}
	
	.firstStairMenuAct{
		background-color: #77A8F2!important;
	}
</style>